export enum PhotoPopupTip {
  AddToGalleries = 'Saving photos to galleries is limited to 2 photos at a time',
  AddAsImagePair = 'Saving image pair to gallery is available after selecting 2 photos. Please try again',
}
